var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackfb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1502 9.425C20.1502 4.22021 15.7677 0 10.3627 0C4.95772 0 0.575195 4.22021 0.575195 9.425C0.575195 14.1291 4.15375 18.0283 8.8334 18.736V12.1503H6.34764V9.425H8.8334V7.34855C8.8334 4.98683 10.295 3.68122 12.5304 3.68122C13.6013 3.68122 14.7216 3.86551 14.7216 3.86551V6.18516H13.4868C12.2717 6.18516 11.8916 6.91139 11.8916 7.65781V9.425H14.6058L14.1724 12.1503H11.892V18.7368C16.5716 18.0295 20.1502 14.1303 20.1502 9.425Z",
    fill: "#1F2732"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackfb);
export default __webpack_public_path__ + "static/media/blackfb.c834fb5f78b7ed878e6bc0a7cf6af5b4.svg";
export { ForwardRef as ReactComponent };